import Card from './Card/Card';
import Compact from './Compact/Compact';

const templates = {
  Card,
  Compact
};

export default templates;